import { render, staticRenderFns } from "./org-upperbar.vue?vue&type=template&id=fed9f5b6&"
import script from "./org-upperbar.vue?vue&type=script&lang=js&"
export * from "./org-upperbar.vue?vue&type=script&lang=js&"
import style0 from "./org-upperbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports